<template lang="pug">
  ul.sub-list.list-reset
    li(v-for="item in data", :key="item.id")
      a(:href="item.origin_url", target="_blank")
        .mt0.mb1.item-title(:title="item.title", data-clamp="2") {{ item.title }}
      .sub
        | {{ item.pub_source }}
        span.px1 |
        | {{ formatUtc(item.pub_utc) }}
</template>

<script>
import moment from 'moment'

import transformImgLink from '@/assets/utils/transformImgLink'
export default {
  props: ['data'],
  methods: {
    shift (link) {
      return transformImgLink(link)
    },
    formatUtc (utc) {
      return moment.unix(utc).format('DD-MM-YYYY HH:mm')
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '../assets/variables.styl';

</style>





// WEBPACK FOOTER //
// sideRightList.vue?41b830b5